import gql from 'graphql-tag';

/**
 * @returns {graphql fragment}
 */

const TransferOrderContractFragment = gql`
  fragment TransferOrderContractFragment on TransferOrderContract {
    editingTimeMin
    cancellationTimeMin
  }
`;

export default TransferOrderContractFragment;



// WEBPACK FOOTER //
// ./src/apolloConst/fragments/TransferOrderContractFragment.js